import subCategoryData from "../data/subcategoryData.json";
import { stripLanguagePrefix } from "./dataProvider";
import { useMediaQuery } from "@vueuse/core";

export const getRandomInt = function (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
};

// https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
export function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export async function toDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
  });
}

export async function dataUrlfromPath(path) {
  let response = await fetch(path);
  let data = await response.blob();
  return await toDataURL(data);
}

// https://stackoverflow.com/questions/923885/capture-html-canvas-as-gif-jpg-png-pdf/3514404#3514404
export async function saveAsPNG(dataURL, fileName) {
  var imgURL = dataURL;
  var MIME_TYPE = "image/png";

  var dlLink = document.createElement("a");
  dlLink.download = fileName;
  dlLink.href = imgURL;
  dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(
    ":",
  );
  document.body.appendChild(dlLink);
  dlLink.click();
  document.body.removeChild(dlLink);
}

export const kebabCase = (string) => {
  return string
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();
};

export const reverseKebabCase = (string) => {
  return string.replace(/-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g, function (match) {
    return " " + match.slice(1).toLowerCase();
  });
};

export const getSubcategoryImageUrl = (subcategory) => {
  if (!subcategory) return;

  let url = subCategoryData[subcategory]?.url;

  return url;
};

export const getSubcategoryBg = (subcategory) => {
  if (!subcategory) return;

  let color = subCategoryData[subcategory]?.bgColor;
  return color ? color : "#f2f2f2";
};

const pastelColors = [
  "#FFEAEA",
  "#EAEEFF",
  "#FFF9EA",
  "#EAFFF9",
  "#F7EAFF",
  "#F6FFEA",
  "#EAF7FF",
];

export const getRandomPastelColor = () => {
  // return pastelColors[getRandomInt(0, pastelColors.length - 1)]
  return `hsl(${getRandomInt(0, 360)},100%, 97%)`;
};

export function getColorForHexBg(hexColor) {
  let rgbColor = hexToRgb(hexColor);
  return getTextColorBasedOnBg(rgbColor);
}

export function getTextColorBasedOnBg(
  rgbColor,
  lightColor = "white",
  darkColor = "black",
) {
  return rgbColor.r * 0.299 + rgbColor.g * 0.587 + rgbColor.b * 0.114 > 186
    ? darkColor
    : lightColor;
}

// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
function hexToRgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

export function isMobile() {
  // if (typeof window === "undefined" || typeof navigator === "undefined") {
  //   return false;
  // }
  // let check = false;
  // (function (a) {
  //   if (
  //     /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
  //       a,
  //     ) ||
  //     /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
  //       a.substr(0, 4),
  //     )
  //   )
  //     check = true;
  // })(navigator.userAgent || navigator.vendor || window.opera);
  // return check;
  const isMobile = useMediaQuery("(max-width: 767px)");
  return isMobile.value;
}

export function getPaddedImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    reader.readAsDataURL(file);

    reader.onloadend = (event) => {
      var img = new Image();
      img.src = event.target.result;

      img.onload = function () {
        let padding = 6;
        let width = img.width;
        let height = img.height;

        if (width > 2000 || height > 2000) {
          let aspectRation = width / height;

          if (height > 2000) {
            height = 2000;
            width = 2000 * aspectRation;
          } else if (width > 2000) {
            width = 2000;
            height = 2000 / aspectRation;
          }
        }

        canvas.width = width + padding;
        canvas.height = height + padding;
        ctx.drawImage(img, padding / 2, padding / 2, width, height);
        resolve(canvas.toDataURL());
      };
    };
    reader.onerror = reject;
  });
}

export function getPaddedImageUrl(file) {
  return new Promise((resolve, reject) => {
    let imgUrl = URL.createObjectURL(file);
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    var img = new Image();
    img.src = imgUrl;

    img.onload = function () {
      let padding = 6;
      let width = img.width;
      let height = img.height;

      if (width > 2000 || height > 2000) {
        let aspectRation = width / height;

        if (height > 2000) {
          height = 2000;
          width = 2000 * aspectRation;
        } else if (width > 2000) {
          width = 2000;
          height = 2000 / aspectRation;
        }
      }

      canvas.width = width + padding;
      canvas.height = height + padding;
      ctx.drawImage(img, padding / 2, padding / 2, width, height);

      //canvas to blob
      canvas.toBlob(function (blob) {
        //blob to url
        let url = URL.createObjectURL(blob);
        resolve({ url, base64: canvas.toDataURL() });
      });
    };
  });
}

export function getImageUrlFromLocalStorage(
  storageKey,
  origin,
  persist = false,
) {
  return new Promise(async (resolve) => {
    if (persist && storageKey == "design-file") {
      let blobUrl = await getBlobUrlFromBase64(storageKey);
      resolve(blobUrl);
    }
    //get URL from local storage
    let url = localStorage.getItem(storageKey);
    if (url) {
      let img = new Image();
      img.src = url;
      img.onload = function () {
        if (origin == "editor" && storageKey == "design-file") {
          let base64 = localStorage.getItem(storageKey + "-base64");
          base64 ? resolve(base64) : resolve(null);
        } else {
          resolve(url);
        }
      };
      img.onerror = function (e) {
        localStorage.removeItem(storageKey);
        if (origin == "editor" && storageKey == "design-file")
          localStorage.removeItem(storageKey + "-base64");
        resolve(null);
      };
    } else {
      resolve(null);
    }
  });
}

function getBlobUrlFromBase64(storageKey) {
  return new Promise(async (resolve) => {
    let base64Image = localStorage.getItem(storageKey + "-base64");
    if (!base64Image) {
      resolve(null);
    }

    let res = await fetch(base64Image);
    let blob = await res.blob();
    let blobUrl = URL.createObjectURL(blob);
    localStorage.setItem(storageKey, blobUrl);

    resolve(blobUrl);
  });
}

export function isDesignOnTop(subcategories) {
  let subcategoriesForDesignOnTop = ["sticker"];
  let designOnTop = false;

  for (let i = 0; i < subcategories.length; i++) {
    if (subcategoriesForDesignOnTop.indexOf(subcategories[i]) > -1) {
      designOnTop = true;
      break;
    }
  }

  return designOnTop;
}

export function getBrowserInfo() {
  if (navigator.userAgent.match(/chrome|chromium|crios/i)) {
    return "Chrome";
  } else return "Other";
}

export function getMobileOS() {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return "Android";
  } else if (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    return "iOS";
  }
  return "Other";
}

export function environment() {
  if (
    window.location.hostname == "localhost" ||
    window.location.hostname == "dev.mockey.ai" ||
    window.location.hostname.endsWith("mocky.pages.dev")
  ) {
    return "dev";
  } else if (window.location.hostname == "mockey.ai") {
    return "prod";
  } else {
    return "dev";
  }
}

export function getExpiryDate(currentTime, timeInterval) {
  const date = new Date(currentTime);
  date.setTime(date.getTime() + timeInterval * 60 * 60 * 1000);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes} | ${day}-${month}-${year}`;
}

export async function storeImageUrls(urls, prompt, original, email) {
  console.log(urls, prompt, original, email);
  const currentTime = new Date().getTime();
  const images = JSON.parse(localStorage.getItem(email)) || {
    user: {},
    images: [],
  };

  if (!images?.images?.length) {
    images.user = { email };
  }
  console.log(urls, prompt, original, email);

  const imageData = {
    original,
    prompt,
    urls,
    timestamp: currentTime,
    expireOn: getExpiryDate(currentTime, 24),
  };
  images.images.push(imageData);
  console.log(urls, prompt, original, email);

  localStorage.setItem(email, JSON.stringify(images));
}

export async function checkAndDeleteInvalidOrExpiredUrls(email) {
  const storedData = localStorage.getItem(email);
  let images = storedData ? JSON.parse(storedData) : { user: {}, images: [] };
  const currentTime = new Date().getTime();

  images.images = await Promise.all(
    images.images.map(async (item) => {
      if (currentTime > item.expireOn) {
        return null; // Remove expired items
      }
      const isValid = await isImageValid(item.urls[0]);
      return isValid ? item : null; // Keep item only if the image is valid
    }),
  );

  images.images = images.images.filter((item) => item !== null);
  localStorage.setItem(email, JSON.stringify(images));
}

export async function isImageValid(url) {
  try {
    const response = await fetch(url);
    return response.ok;
  } catch (error) {
    return false;
  }
}

export function getStoredImages(location) {
  const images = JSON.parse(localStorage.getItem(location)) || [];
  return images;
}

export function extractTags(data) {
  const tags = data.flatMap((item) => item?.meta?.tags || []);
  // Convert all tags to lowercase for case-insensitive comparison and remove extra spaces
  const lowerCaseTags = tags.map((tag) => tag.trim().toLowerCase());
  const uniqueTags = [...new Set(lowerCaseTags)];
  return uniqueTags;
}

export function extractTagFromRoute(text) {
  if (text === "beanie-hat") return "beanie-hat";
  if (text === "mug-logo") return "mug-logo";
  if (text === "ipad-pro") return "ipad-pro";
  if (text === "macbook-pro-mockup") return "macbook-pro-mockup";
  if (text === "macbook-pro-m1") return "macbook-pro-m1";
  if (text === "macbook-air-m2") return "macbook-air-m2";
  if (text === "macbook-air-m1") return "macbook-air-m1";
  if (text === "cosmetic-jar") return "jar";
  if (text === "cosmetic-spray") return "spray";
  if (text === "cosmetic-bottle") return "bottle";
  if (text === "cosmetic-tube") return "tube";
  if (text === "cosmetic-cream") return "cream";
  if (text === "business-card-stack") return "business-card-stack";
  if (text === "round-perfume-bottle") return "round-perfume-bottle";
  if (text === "square-perfume-bottle") return "square-perfume-bottle";
  if (text === "black-perfume-bottle") return "black-perfume-bottle";
  if (text === "pocket-perfume-bottle") return "pocket-perfume-bottle";
  if (text === "book-cover") return "cover-book";
  const wordsToRemove =
    /\b(t-shirt|tshirt|hoodie|tank-top|sweatshirt|jacket|tote-bag|cap|bottle|book|beanie|gaming-pad|sticker|poster|mug|cushion|box|flyer|greeting-card|billboard|frame|magazine|lanyard|banner|canvas|notebook|iPad|phone|can|apron|coaster|scarf|pouch|perfume|cosmetic|tube|dropper-bottle|jewelry|macbook|brochure|crop-top|ring|necklace|bracelet|earring|jersey|business-card|sweatpants)\b/gi;
  const match = text.match(wordsToRemove);

  if (match) {
    const lastMatch = match[match.length - 1];
    const index = text.lastIndexOf(lastMatch);
    const truncatedText = text
      .substring(0, index)
      .replace(/-$/, "")
      .replace(/-/g, " ")
      .trim();
    return truncatedText;
  } else {
    // If none of the words to remove are found, split text at hyphens and return first two words
    const cleanedText = text.replace(/-/g, " ").trim();
    const words = cleanedText.split(/\s+/); // Split the text into words
    return words.join(" "); // Return the first two words joined by a space
  }
}

export function updateObjectValues(obj, keys) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (!keys.includes(key)) {
        obj[key] = false;
      }
    }
  }
}

export function generateBreadcrumbs(path) {
  const refinedPath = stripLanguagePrefix(path);
  const segments = refinedPath.split("/").filter((segment) => segment !== "");
  return segments.map((segment, index) => {
    return "/" + segments.slice(0, index + 1).join("/");
  });
}

export function getBreadcrumbName(link) {
  return link
    .split("/")
    .filter((segment) => segment !== "")
    .pop();
}

export function replaceSpaces(str) {
  if (!str) return;
  // Trim leading and trailing spaces to preserve them
  const trimmedStr = str.trim();
  // Replace internal spaces with dashes
  const replacedStr = trimmedStr.replace(/\s+/g, "-");

  return replacedStr;
}

export function getSubcatFromRoute(route) {
  const parts = route.split("/").filter((part) => part.length > 0); // Split and remove empty strings
  const lastSecondString = parts[parts.length - 2];
  return lastSecondString ?? null;
}
export async function jsonToFile(jsonData, fileName) {
  // Convert the JSON data to a string
  const jsonString =
    typeof jsonData === "string" ? jsonData : JSON.stringify(jsonData);
  // Create a Blob from the JSON string
  const blob = new Blob([jsonString], { type: "application/json" });
  // Convert the Blob into a File object
  return new File([blob], fileName, { type: "application/json" });
}

export function extractSubCategoryFromRoute(text) {
  if (categoryDictionary[text]) {
    return categoryDictionary[text];
  }
  const categoryRegex =
    /t-shirt|tshirt|hoodie|tank-top|sweatshirt|jacket|crop-top|tote-bag|cap|bottle|book|beanie|phone-cover|gaming-pad|id-card|business-card|sticker|poster|mug|cushion|box|flyer|greeting-card|iPhone|iphone|laptop|case|billboard|frame|magazine|lanyard|banner|canvas|notebook|iPad|ipad|phone|can|apron|coaster|scarf|pouch|perfume|cosmetic|tube|dropper-bottle|jewelry|macbook|brochure|ring|necklace|bracelet|earring|jersey|sweatpants/gi;
  const match = text.match(categoryRegex);
  if (match?.at(-1) == "case") return "phone-cover";
  if (match) {
    return match.at(-1) == "tshirt" ? "t-shirt" : match.at(-1);
  } else {
    return null;
  }
}

export function findCategoryFromSubCat(data, subcategory) {
  for (const [category, subcategories] of Object.entries(data)) {
    if (subcategories.includes(subcategory)) {
      return category;
    }
  }
  return null;
}

export const tagDictionary = {
  "cap hat": "cap-hat",
  jar: "cosmetic-jar",
  spray: "cosmetic-spray",
  bottle: "cosmetic-bottle",
  tube: "cosmetic-tube",
  cream: "cosmetic-cream",
  hat: "hat",
  notebook: "notebook",
  "spring notebook": "spring-notebook",
  "desk mat": "desk-mat",
  "blank desk mat": "blank-desk-mat",
  "white desk pad": "white-desk-pad",
  "beanie hat": "beanie-hat",
  "beanie-hat": "beanie-hat",
  "id badge": "id-badge",
  "id lanyard": "id-lanyard",
  "id card holder": "id-card-holder",
  "id badge holder": "id-badge-holder",
  "badge identity": "badge-identity-card",
  "id holder": "id-holder",
  "plastic id holder": "plastic-id-holder",
  "string lanyard": "string-lanyard",
  "business card stack": "business-card-stack",
  "square sticker": "square-sticker",
  "poster frame": "poster-frame",
  "can bottle": "can-bottle",
  "mug logo": "mug-logo",
  "oneplus 10t": "oneplus-10t-phone-case",
  "oneplus 10t phone case": "oneplus-10t-phone-case",
  "samsung tab s8 ultra": "samsung-tab-s8-ultra",
  "smartphone galaxy s23": "smartphone-galaxy-s23",
  tough: "tough-case",
  "iphone case": "iphone-case",
  "iphone screen": "iphone-screen",
  "iphone ui": "iphone-ui",
  "iphone 6 case": "iphone-6-case",
  "iphone 6 plus case": "iphone-6-plus-case",
  "iphone xs": "iphone-xs",
  "iphone x": "iphone-x",
  "iphone x case": "iphone-x-case",
  "iphone 11": "iphone-11",
  "iphone 11 pro case": "iphone-11-pro-case",
  "iphone 12": "iphone-12",
  "iphone 13": "iphone-13",
  "iphone 14": "iphone-14",
  "iphone 14 pro": "iphone-14-pro",
  "iphone 14 pro case": "iphone-14-pro-case",
  "iphone 14 case": "iphone-14-case",
  "iphone 15": "iphone-15",
  "iphone 15 plus": "iphone-15-plus",
  "iphone 15 pro": "iphone-15-pro",
  "iphone 15 pro max": "iphone-15-pro-max",
  "iphone 15 pro max case": "iphone-15-pro-max-case",
  "iphone 15 pro case": "iphone-15-pro-case",
  "iphone 16": "iphone-16",
  "iphone 16 plus": "iphone-16-plus",
  "iphone 16 pro": "iphone-16-pro",
  "3d iphone case": "3d-iphone-case",
  "2d phone case": "2d-phone-case",
  "android phone case": "android-phone-case",
  "black iphone case": "black-iphone-case",
  "bundle iphone case": "bundle-iphone-case",
  "realme 10 phone case": "realme-10-phone-case",
  "white iphone case": "white-iphone-case",
  "x20 phone case": "x20-phone-case",
  "laptop case": "laptop-case",
  "macbook air": "macbook-air",
  "laptop device": "laptop-device",
  "m3 macbook pro": "m3-macbook-pro",
  "macbook 15 pro": "macbook-15-pro",
  "macbook pro mockup": "macbook-pro-mockup",
  "macbook pro m1 mockup": "macbook-pro-m1",
  "macbook pro m2 mockup": "macbook-pro-m2",
  "macbook air m2 mockup": "macbook-air-m2",
  "macbook air m1 mockup": "macbook-air-m1",
  "air macbook": "macbook-air",
  "macbook 16 pro": "macbook-16-pro",
  "ipad pro": "ipad-pro",
  "air ": "ipad-air",
  mini: "ipad-mini",
  "round perfume bottle": "round-perfume-bottle",
  "square perfume bottle": "square-perfume-bottle",
  "black perfume bottle": "black-perfume-bottle",
  "pocket perfume bottle": "pocket-perfume-bottle",
  cover: "book-cover",
};

export const categoryDictionary = {
  iphone: "iphone",
  case: "phone-cover",
  "oneplus-10t": "phone-cover",
  "samsung-tab-s8-ultra": "phone-cover",
  "smartphone-galaxy-s23": "phone-cover",
  "desk-mat": "gaming-pad",
  "blank-desk-mat": "gaming-pad",
  "white-desk-pad": "gaming-pad",
  "id-badge": "id-card",
  "id-lanyard": "id-card",
  "id-card-holder": "id-card",
  "id-badge-holder": "id-card",
  "badge-identity-card": "id-card",
  "plastic-id-holder": "id-card",
  "string-lanyard": "id-card",
  "business-card-stack": "business-card",
  "macbook-air": "laptop",
  "m3-macbook-pro": "laptop",
  "macbook-15-pro": "laptop",
  "macbook-16-pro": "laptop",
  "beanie-hat": "beanie",
  hat: "cap",
  "cosmetic-bottle": "cosmetic",
  "macbook-pro-mockup": "macbook",
  "macbook-pro-m1": "macbook",
  "square-perfume-bottle": "perfume",
  "round-perfume-bottle": "perfume",
  "pocket-perfume-bottle": "perfume",
  "black-perfume-bottle": "perfume",
  "cosmetic-tube": "cosmetic",
};

export function colorExtractor(query) {
  const colorRegex =
    /black|white|blue|red|gray|green|navy|pink|yellow|brown|beige|purple|orange|burgundy|olive/gi;
  const match = query.match(colorRegex);
  if (match) {
    const color = { hex: colorDictionary[match.at(-1)] };
    return color;
  } else return null;
}

export const colorDictionary = {
  black: "#000000",
  white: "#FFFFFF",
  blue: "#266EF1",
  red: "#FF0000",
  gray: "#808080",
  green: "#008000",
  navy: "#000080",
  pink: "#FFC0CB",
  yellow: "#FFFF00",
  brown: "#A52A2A",
  beige: "#F5F5DC",
  purple: "#800080",
  orange: "#FFA500",
  burgundy: "#800020",
  olive: "#808000",
};

export function capitalize(sentence) {
  if (!sentence) return;
  return sentence
    ?.replace(/-/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function generateDynamicTemplate(template, tag, templateName) {
  if (!template) return null;
  let tags = "";
  if (tag == "3d") {
    tags = templateName == "beanie-tag" ? `3D Beanie` : tag.toUpperCase();
  } else if (templateName == "beanie-tag" && tag != "beanie-hat") {
    tags = capitalize(`${tag} Beanie`);
  } else if (templateName == "mug-tag" && tag != "mug-logo") {
    tags = capitalize(`${tag} Mug`);
  } else if (templateName == "iphone-tag") {
    tags = tag;
  } else if (templateName == "cosmetic-tag" && !tagDictionary[tag]) {
    tags = capitalize(`${tag} Cosmetic`);
  } else {
    tags = capitalize(tag);
  }
  const templateString = JSON.stringify(template);
  const replacedString = templateString.replace(/{tag}/g, tags);
  return JSON.parse(replacedString);
}

export function createUniqueTags(names, numTags) {
  const tags = new Set();
  for (let name of names) {
    const words = name.split("-");
    let tag = "";

    for (let i = 0; i < Math.min(3, words.length); i++) {
      tag += (i === 0 ? "" : "-") + words[i];
    }

    tags.add(tag);
    if (tags.size >= numTags) break;
  }

  return Array.from(tags);
}
export const categoriesList = {
  apparel: [
    "t-shirt",
    "tank-top",
    "hoodie",
    "sweatshirt",
    "jacket",
    "crop-top",
    "apron",
    "scarf",
    "jersey",
    "sweatpants",
  ],
  accessories: ["tote-bag", "cap", "phone-cover", "beanie", "gaming-pad"],
  "home-and-living": ["can", "mug", "cushion", "frame", "coaster"],
  print: [
    "business-card",
    "book",
    "id-card",
    "sticker",
    "poster",
    "flyer",
    "greeting-card",
    "billboard",
    "magazine",
    "brochure",
    "lanyard",
    "banner",
    "canvas",
    "notebook",
  ],
  packaging: [
    "box",
    "tube",
    "dropper-bottle",
    "pouch",
    "cosmetic",
    "bottle",
    "perfume",
  ],
  tech: ["iphone", "laptop", "ipad", "macbook", "phone"],
  jewelry: ["ring", "necklace", "bracelet", "earring"],
};
export function findCategoryOrSubcategory(text) {
  // Normalize the input text by removing hyphens and converting to lowercase
  const normalizedText = text.toLowerCase().replace(/-/g, "");
  for (const category in categoriesList) {
    if (categoriesList?.[category]) {
      const normalizedCategory = category.toLowerCase().replace(/-/g, "");
      if (normalizedCategory === normalizedText) {
        return {
          type: "category",
          value: category,
          addOn: `${category} mockup`,
        };
      }
      const normalizedItems = categoriesList[category].map((item) =>
        item.toLowerCase().replace(/-/g, ""),
      );
      if (normalizedItems.includes(normalizedText)) {
        return { type: "subcategory", value: text, addOn: text };
      }
    }
  }
  return null;
}

export function extractNormalisedSubCategory(text) {
  if (categoryDictionary[text]) {
    return categoryDictionary[text];
  }

  // Update regex to handle both hyphenated and non-hyphenated categories
  const categoryRegex =
    /t-?shirt|hoodie|tank-?top|sweat-?shirt|jacket|tote-?bag|cap|bottle|book|beanie|phone-?cover|gaming-?pad|id-?card|business-?card|sticker|poster|mug|cushion|box|flyer|greeting-?card|iPhone|iphone|laptop|case|billboard|frame|magazine|lanyard|banner|canvas|notebook|iPad|phone|can|apron|coaster|scarf|pouch|perfume|cosmetic|tube|dropper-bottle|jewelry|macbook|brochure|crop-top|ring|necklace|bracelet|earring|jersey|sweat-?pants/gi;

  const match = text.match(categoryRegex);

  if (match?.at(-1) === "case") {
    return "phone-cover";
  }

  if (match) {
    // Normalize the result by returning the hyphenated form of the subcategory
    const normalizedCategories = {
      tshirt: "t-shirt",
      "t-shirt": "t-shirt",
      tanktop: "tank-top",
      "tank-top": "tank-top",
      sweatshirt: "sweat-shirt",
      "sweat-shirt": "sweat-shirt",
      totebag: "tote-bag",
      "tote-bag": "tote-bag",
      phonecover: "phone-cover",
      "phone-cover": "phone-cover",
      gamingpad: "gaming-pad",
      "gaming-pad": "gaming-pad",
      idcard: "id-card",
      "id-card": "id-card",
      businesscard: "business-card",
      "business-card": "business-card",
      greetingcard: "greeting-card",
      "greeting-card": "greeting-card",
    };

    // Ensure we return the hyphenated version, if it exists in normalizedCategories
    return normalizedCategories[match.at(-1).replace(/-/g, "")] || match.at(-1);
  } else {
    return null;
  }
}

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function getOS() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  // Use userAgentData if available
  if (navigator.userAgentData) {
    const platform = navigator.userAgentData.platform || "";
    if (platform.includes("Mac")) {
      return "Mac";
    } else if (platform.includes("Windows")) {
      return "Windows";
    }
  }

  // Fallback to userAgent
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes("mac")) {
    return "Mac";
  } else if (userAgent.includes("windows")) {
    return "Windows";
  }

  return "Other";
}

export function checkDate(dateString) {
  const targetDate = new Date(dateString);
  const currentDate = new Date();

  const timeDifference = targetDate.getTime() - currentDate.getTime();
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

  if (daysDifference <= 5 && daysDifference >= 0) {
    return true;
  } else return false;
}

export function getResponsiveStyle() {
  if (window.matchMedia("(max-width: 640px)").matches) {
    // Mobile styles
    return {
      borderRadius: "8px",
      right: "0px",
      textAlign: "left",
      width: "calc(100vw-16px)",
    };
  } else {
    // Desktop styles
    return {
      borderRadius: "8px",
      right: "0px",
      textAlign: "left",
      width: "512px",
    };
  }
}

export function removeMockupKeyword(url) {
  return url.replace(/-mockups?\b/g, "");
}

export function formatName(name) {
  if (!name) return;
  return name
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function getFutureTimestamp(year, month, day, hours, minutes, seconds) {
  // Create a Date object for the future date and time
  const futureDate = new Date(year, month - 1, day, hours, minutes, seconds);
  // Get the timestamp in milliseconds
  return futureDate.getTime();
}

export function startCountdown(endTimestamp, updateCallback) {
  // Calculate the remaining time from the current time to the end timestamp
  function getTimeLeft(endTimestamp) {
    const currentTime = Date.now();
    return endTimestamp - currentTime;
  }

  // Format time in HH:MM:SS
  function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }

  // This function will return the current countdown timer
  function getCountdown() {
    const timeLeft = getTimeLeft(endTimestamp);

    if (timeLeft <= 0) {
      return "00:00:00"; // Countdown finished
    }

    const secondsLeft = Math.floor(timeLeft / 1000); // Convert milliseconds to seconds
    return formatTime(secondsLeft);
  }

  // Update the countdown every second
  const interval = setInterval(() => {
    const countdown = getCountdown();
    updateCallback(countdown); // Call the callback function to update the UI

    // If the countdown is finished, stop the interval
    if (countdown === "00:00:00") {
      clearInterval(interval);
    }
  }, 1000);
}

export function isTimestampValid(timestamp, validHours) {
  const currentTime = Date.now(); // Get current timestamp in milliseconds
  const timeLimit = validHours * 60 * 60 * 1000; // Convert hours to milliseconds

  return currentTime - timestamp <= timeLimit;
}

export async function dataUrlToFile(dataUrl, fileName) {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], fileName, { type: "image/png" });
}

export function getFilteredData(data, filter) {
  if (filter === "free") {
    return data.filter((m) => m.pro != true);
  } else if (filter === "pro") {
    return data.filter((m) => m.pro == true);
  } else if (filter === "bundle") {
    return data.filter((m) => !!m?.bundleId);
  } else return null;
}

export function getExtensionFromUrl(videoUrl) {
  const clean = videoUrl?.split("?")[0].split("#")[0];
  const parts = clean?.split(".");
  return parts?.length > 1 ? parts?.pop()?.toLowerCase() : "";
}

export async function downloadVideoFromUrl(videoUrl, filename = "video.mp4") {
  const res = await fetch(videoUrl);
  if (!res.ok) throw new Error("Network response was not ok");

  const blob = await res.blob(); // get the binary data
  const blobUrl = URL.createObjectURL(blob);

  // create a hidden <a> and click it
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = `${filename}.${getExtensionFromUrl(videoUrl)}` || "video.mp4";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

export async function getBlobSize(blobUrl) {
  const blob = await fetch(blobUrl).then((r) => r.blob());
  const bmp = await createImageBitmap(blob);
  return { width: bmp.width, height: bmp.height };
}

export const selectedKeys = [
  "t-shirt oversized",
  "book",
  "hoodie",
  "box",
  "t-shirt back",
  "tote-bag",
  "poster",
  "business-card",
  "sweatshirt",
  "iphone",
  "frame",
  "mug",
  "cap",
  "billboard",
];

export function getOrganizedMockups(data) {
  const { selectedCategories, allMockups } = Object.values(data || {}).reduce(
    (acc, category) => {
      Object.entries(category || {}).forEach(([key, value]) => {
        if (value && Array.isArray(value)) {
          acc.allMockups.push(...value);
        }

        const isValid = selectedKeys.find((item) => item.split(" ")[0] === key);
        if (isValid) {
          acc.selectedCategories[key] = value;
        }
      });
      return acc;
    },
    { selectedCategories: {}, allMockups: [] },
  );

  const orderedResult = selectedKeys.reduce((result, key) => {
    const [baseKey, modifier] = key.split(" ");

    if (selectedCategories[baseKey]) {
      if (modifier === "oversized") {
        // Only include items that have oversized tag AND haven't been included as "back" yet
        result[key] = selectedCategories[baseKey].filter(
          (item) =>
            item?.meta?.tags?.includes("oversized") &&
            !result[`${baseKey} back`]?.includes(item),
        );
      } else if (modifier === "back") {
        // Only include items that have back tag AND haven't been included as "oversized" yet
        result[key] = selectedCategories[baseKey].filter(
          (item) =>
            item?.meta?.tags?.includes("back") &&
            !result[`${baseKey} oversized`]?.includes(item),
        );
      } else {
        result[key] = selectedCategories[baseKey];
      }
    }
    return result;
  }, {});

  const selectedMockups = Object.values(orderedResult).flat();

  const remainingMockups = allMockups.filter(
    (mockup) => !selectedMockups.includes(mockup),
  );

  const categories = Object.values(orderedResult);
  const maxLength = Math.max(...categories.map((arr) => arr?.length || 0));
  const roundRobin = [];

  for (let i = 0; i < maxLength; i++) {
    for (const categoryMocks of categories) {
      if (categoryMocks?.[i]) {
        roundRobin.push(categoryMocks[i]);
      }
    }
  }

  return [...roundRobin, ...remainingMockups];
}

export function getCreditsData(data) {
  if (!data) return null;
  let topup = 0;
  if (data["topup"]?.length) {
    data["topup"].forEach((item) => {
      topup += item.topup;
    });
  }
  return topup || 0;
}

export const priorityTags = [
  "polo-t-shirt",
  "3d-t-shirt",
  "washed-t-shirt",
  "black-hoodie",
  "white-hoodie",
  "zip-hoodie",
  "pullover-hoodie",
  "full-zip-hoodie",
  "3d-hoodie",
  "black-tank-top",
  "white-tank-top",
  "gym-tank-top",
  "hooded-sweatshirt",
  "black-sweatshirt",
  "crewneck-sweatshirt",
  "white-sweatshirt",
  "bomber-jacket",
  "puffer-jacket",
  "zip-up-jacket",
  "black-jacket",
  "white-crop-top",
  "black-crop-top",
  "barber-apron",
  "chef-apron",
  "silk-scarf",
  "silk-scarf",
  "football-jersey",
  "cricket-jersey",
  "fitted-cap",
  "cycling-cap",
  "baseball-cap",
  "graduation-cap",
  "snapback-cap",
  "golf-cap",
  "hat",
  "white-tote-bag",
  "iphone-case",
  "iphone-14-case",
  "iphone-11-pro-case",
  "black-beanie",
  "beanie-hat",
  "white-beanie",
  "red-beanie",
  "3d-beanie",
  "rectangular-gaming-pad",
  "slant-gaming-pad",
  "coffee-mug",
  "ceramic-mug",
  "metal-mug",
  "soda-can",
  "beer-can",
  "hand-holding-can",
  "coffee-can",
  "paper-can",
  "drink-can",
  "photo-frame",
  "picture-frame",
  "square-cushion",
  "sofa-cushion",
  "square-coaster",
  "square-book",
  "3d-book",
  "book-cover",
  "book-cover",
  "open-magazine",
  "a4-magazine",
  "roll-up-banner",
  "street-banner",
  "hanging-banner",
  "vertical-banner",
  "horizontal-banner",
  "trifold-brochure",
  "a4-brochure",
  "bifold-brochure",
  "a4-flyer",
  "landscape-flyer",
  "business-card-stack",
  "floating-business-card",
  "horizontal-business-card",
  "vertical-business-card",
  "rounded-business-card",
  "hand-holding-business-card",
  "circle-business-card",
  "outdoor-poster",
  "square-poster",
  "street-poster",
  "horizontal-poster",
  "hanging-poster",
  "vertical-poster",
  "interior-poster",
  "wall-poster",
  "paper-poster",
  "room-poster",
  "large-poster",
  "advertising-poster",
  "vertical-canvas",
  "interior-canvas",
  "event-lanyard",
  "badge-lanyard",
  "id-lanyard",
  "advertising-billboard",
  "vertical-billboard",
  "street-billboard",
  "landscape-billboard",
  "nyc-billboard",
  "roadside-billboard",
  "wide-billboard",
  "water-bottle",
  "wine-bottle",
  "glass-bottle",
  "juice-bottle",
  "pill-bottle",
  "plastic-bottle",
  "supplement-bottle",
  "rectangular-box",
  "gift-box",
  "product-box",
  "square-box",
  "mailing-box",
  "long-box",
  "cardboard-box",
  "sweet-box",
  "pizza-box",
  "cardboard-tube",
  "plastic-tube",
  "skincare-tube",
  "amber-dropper-bottle",
  "frosted-dropper-bottle",
  "glass-dropper-bottle",
  "coffee-pouch",
  "flat-pouch",
  "paper-pouch",
  "square-pouch",
  "zip-pouch",
  "cosmetic-jar",
  "cosmetic-tube",
  "cosmetic-spray-bottle",
  "cosmetic-cream",
  "cosmetic-pump-bottle",
  "round-perfume",
  "square-perfume",
  "black-perfume",
  "iphone-16",
  "iphone-15",
  "iphone-14",
  "iphone-screen",
  "ipad-pro",
  "3d-ipad",
  "clay-ipad",
  "android-phone",
  "smartphone-phone",
  "hand-holding-phone",
  "nothing-phone",
  "horizontal-phone",
  "google-pixel-phone",
  "samsung-phone",
  "flat-laptop",
  "dark-laptop",
  "gaming-laptop",
  "dell-laptop",
  "hp-laptop",
  "asus-laptop",
  "acer-laptop",
  "razer-laptop",
  "apple-laptop",
  "macbook-pro-mockup",
  "air-macbook",
  "floating-macbook",
  "flat-macbook",
  "hand-holding-macbook",
  "engagement-ring",
  "wedding-ring",
  "pendant-necklace",
  "choker-necklace",
  "bangles-bracelet",
  "stud-earring",
];
